/**
 * Which query keys a default-scene write has to invalidate.
 *
 * The legacy pair is always stale after a write. Under bgDerivation the page
 * reads its defaults and its background list from the v3 endpoints instead, so
 * those have to go too — otherwise the panel reports "saved"/"undone" while the
 * page keeps serving the pre-write catalog until staleTime expires.
 */
export function invalidatedQueryKeys(bgDerivation: boolean): string[][] {
  const keys = [["default-scene-overrides"], ["fetch-initial-scene"]];
  if (bgDerivation) {
    // "-all" is its own ROOT key (useResolvedDefaultScenesAll), not a longer
    // "v3-resolved-default" key — invalidating the latter does not match it.
    keys.push(["v3-resolved-default"], ["v3-resolved-default-all"], ["v3-backgrounds"]);
  }
  return keys;
}
